<template>
  <div class="work-space-data-container">
    <div class="work-space-data-control">
      <span
        v-for="(control, index) of controlList"
        :key="index"
        @click="control['fun']"
        :title="control['title']"
      >
        <svg-icon :iconName="control['icon']"></svg-icon>
      </span>
    </div>
    <el-scrollbar class="work-space-data-scrollbar">
      <div class="work-space-data-item"
        v-for="(item) of dataList"
        :key="item"
        @click="workSpaceDataClick(item)"
        :class="{
          'isHovered': item[checkProp],
        }"
      >
        <div class="item-title ellipsis">
          <!-- <el-checkbox
            v-model="item['checkFlag']"
            :disabled="item['disabled']"
            @change="workSpaceDataChange(item, $event)"
          ></el-checkbox> -->
          <svg-icon iconName="load-icon"
            v-if="item[loadingProp]"
          ></svg-icon>
          {{ item['name'] }}
        </div>
        <div class="item-control">
          <!-- <span title="保存" @click.stop="saveFn(item)"
            v-if="item == workSpaceDataTarget"
          >
            <svg-icon iconName="save"></svg-icon>
          </span> -->
          <span title="删除" @click.stop="deleteFn(item)">
            <svg-icon iconName="el-Delete"></svg-icon>
          </span>
        </div>
      </div>
    </el-scrollbar>
    <!-- <EditDraw
      ref="EditDrawRef"
      :bizType="3"
      :layerList="[workSpace]"
    /> -->
    <WorkSpaceDataEdit 
      v-if="WorkSpaceDataEditShowFlag"
      title="新增数据"
      @close="WorkSpaceDataEditShowFlagChange(false)"
      @submitCallback="dataInit"
      :workSpace="workSpace"
      :AirAndWarshipList="AirAndWarshipList"
    />
    <WorkDataInit
      v-if="workDataTarget"
      title="数据初始化"
      @close="workDataTargetChange(undefined)"
      @submitCallback="workSubmitCallback"
    ></WorkDataInit>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, toRaw,
} from 'vue';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';
import store from '@/store';
import { ElMessageBox } from 'element-plus';

import WorkSpaceDataEdit from './components/WorkSpaceDataEdit';
import WorkDataInit from './components/WorkDataInit';
import CustomLocaleControl from './components/CustomLocaleControl';

import EditDraw from '@/views/Home/component/ManagePanel/components/CustomPolygon/components/EditDraw';

import { aiComponentCreate, } from './utils';

import {
  queryUserWorkspaceDataList, delUserWorkspaceData,
  queryUserWorkspaceDataDetail, saveUserWorkspaceData,
  loadUserWorkspaceData,
} from '@/api/UserWorkspaceApi';

import {
  queryFavoriteDetail,
} from '@/api/UserDrawApi';

import {
  getAllAirAndWarshipType,
} from '@/api/DictApi';

import {
  queryAnnotation, saveAnnotation,
} from '@/api/UserWorkspaceDataApi';

import {
  queryRegionAnalysisResult, saveOrUpdateRegionAnalysisResult,
  deleteRegionAnalysisResult,
} from '@/api/RegionAnalysisResultApi';

// props
const props = defineProps({
  workSpace: { type:Object, required: true, },
});
// emit
const emit = defineEmits([
  'close',
]);

const close = ()=>{ emit('close'); }

const homeMap = computed(()=> store.getters['getHomeMap'] ),
      map = toRaw(homeMap.value),
      layerGroup = L.featureGroup().addTo(map),
      layerGroupClose = ()=>{
        map.removeLayer(layerGroup);
      },
      layerGroupClear = ()=>{
        layerGroup.clearLayers();
      }
const loadingProp = ref('loading'), checkProp = ref('check');
const geojsonProp = 'geojsonData';
const workSpaceDataClick = (target)=>{
  // if(workSpaceDataLoad.value){
  //   return;
  // }
  // layerGroupClear();
  const group = target[geojsonProp];
  if(target[checkProp.value]){
    group && layerGroup.removeLayer(group);
  }else{
    if(group){
      layerGroup.addLayer(group);
    }else{
      target[loadingProp.value] = true;
      queryUserWorkspaceDataDetail(target['id']).then(res=>{
        if(res.data.code == 1004){
          // dataLayerInit(target, res.data.data);
          dataLayerInit_New(target, res.data.data);
        }
        target[loadingProp.value] = false;
      }).catch(err=>{
        target[loadingProp.value] = false;
        console.log(err);
      });
    }
  }
  target[checkProp.value] = !target[checkProp.value];
  
}
const polygonStyle = store.getters['leafletPolygon/polygonStyle'],
      polygonMoveStyle = {
        color: 'rgb(234, 93, 41)',
      }

const dataLayerInit_New = (target, data)=>{
  // console.log(target, data);
  const list = data['userWorkspaceGeoJsonDataPOList'] || [];
  const group = L.featureGroup();
  const dataInit = (item)=>{
    // console.log(item);
    const geom = JSON.parse(item['geom']);
    let layer;
    L.geoJSON(geom, {
      onEachFeature: (feature, e)=>{
        if(e instanceof L.Polyline && !(e instanceof L.Polygon)){
          e.setStyle({
            weight: 4,
          })
        }
        layer = e;
      }
    })
    if(!layer)return;
    
    layer.on({
      mouseover: event=>{
        event.target.setStyle && event.target.setStyle({
          ...polygonMoveStyle,
        })
      },
      mouseout: event=>{
        event.target.setStyle && event.target.setStyle({
          ...polygonStyle,
        })
      },
      remove: event=>{
        event.target.setStyle && event.target.setStyle({
          ...polygonStyle,
        })
      },
    })
    const properties = layer['feature']['properties'];
    let text = '';
    for(let key in properties){
      text+=`<p>${key}：${properties[key]}</p>`
    }
    if(text.length>0){
      layer.bindPopup(text, {
        closeButton: false,
        autoClose: false,
        // offset: [0, 10],
        // sticky: true,
        className: "leaflet-popup-message work-space-popup",
        direction: 'top',
        // maxWidth: 300,
        // maxHeight: 20,
        // permanent: false,
      });
    }
    delIdMap.set(item['id'], layer._leaflet_id);

    layer.addTo(group);
  }
  const RICFn = (deadline)=>{
    while (deadline.timeRemaining() > 0 && list.length > 0) {
      const item = list.shift();
      dataInit(item);
    }
    // console.log(list.length);
    if(list.length == 0){
      layerGroup.addLayer(group);
      target[geojsonProp] = group;
      return;
    }else{
      requestIdleCallback(RICFn);
    };
  }
  requestIdleCallback(RICFn);
}

const dataLayerInit = (target, data)=>{
  const geojson = data?data['geojsonData']:target[geojsonProp],
        group = L.featureGroup();
  // console.log(geojson);
  L.geoJSON(
    JSON.parse(geojson),
    {
      // renderer: L.canvas(),
      onEachFeature: (feature, layer)=>{
        if(layer instanceof L.Polyline && !(layer instanceof L.Polygon)){
          layer.setStyle({
            weight: 4,
          })
        }
      }
    }
  ).eachLayer(layer=>{
    layer.on({
      mouseover: event=>{
        event.target.setStyle && event.target.setStyle({
          ...polygonMoveStyle,
        })
      },
      mouseout: event=>{
        event.target.setStyle && event.target.setStyle({
          ...polygonStyle,
        })
      },
      remove: event=>{
        event.target.setStyle && event.target.setStyle({
          ...polygonStyle,
        })
      },
    })
    const properties = layer['feature']['properties'];
    let text = '';
    for(let key in properties){
      text+=`<p>${key}：${properties[key]}</p>`
    }
    if(text.length>0){
      layer.bindTooltip(text, {
        // offset: [0, 10],
        // sticky: true,
        className: "leaflet-tooltip-message  work-space-popup",
        direction: 'top',
        // maxWidth: 300,
        // maxHeight: 20,
        // permanent: true,
      });
    }

    layer.addTo(group);
  })
  layerGroup.addLayer(group);
  const bounds = layerGroup.getBounds();
  bounds.isValid() && map.fitBounds(bounds);
  target[geojsonProp] = group;
}

const saveFn = (target)=>{
  const geojson = layerGroup.toGeoJSON();
  // console.log(geojson);
  ElMessageBox.confirm(
    '是否保存并更新当前数据？',
    '编辑数据',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(res=>{
    saveUserWorkspaceData({
      dataId: target['id'],
      data: JSON.stringify(geojson),
    }).then(res=>{
      if(res.data.code == 1004){
        message(res.data.msg, 1);
        target[geojsonProp] = JSON.stringify(geojson);
      }
    }).catch(err=>{
      console.log(err);
    });
  }).catch(err=>{
    console.log(err);
  });
}

const deleteFn = (target)=>{
  ElMessageBox.confirm(
    '是否删除当前数据？',
    '删除数据',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(res=>{
    delUserWorkspaceData(target['id']).then(res=>{
      if(res.data.code == 1004){
        message(res.data.msg, 1);
        dataInit();
      }
    }).catch(err=>{
      console.log(err);
    });
  }).catch(err=>{
    console.log(err);
  });

}

const WorkSpaceDataEditShowFlag = ref(false),
      WorkSpaceDataEditShowFlagChange = (flag)=>{
        WorkSpaceDataEditShowFlag.value = flag;
      }
const addWorkSpaceDataFn = ()=>{
  WorkSpaceDataEditShowFlagChange(true);
}

const fileImportFn = ()=>{
  // console.log('12313');
}
const workDataLoad = ref(false), workDataLoadChange = (flag)=>{ workDataLoad.value = flag; },
workDataTarget = ref(undefined), workDataTargetChange = (target)=>{
  workDataTarget.value = target;
  if(target == undefined){
    workDataLoadChange(false);
  }
},
workDataInit = ()=>{
  if(workDataLoad.value)return;
  workDataLoadChange(true);
  workDataTarget.value = Object.assign({});
},
workSubmitCallback = (target)=>{
  workDataTargetChange(undefined);
  const data = {
    ...target,
    workspaceId: props.workSpace['id'],
  };
  Promise.all([
    loadUserWorkspaceData({
      ...data, models: [ "MQ-4C", "E-3C", "E-3G", "E-737" ],
      dataType: 6, dataName: 'track', trackType: 'air',
      classification: '侦察预警机',
    }),
    loadUserWorkspaceData({ ...data, dataType: 1, dataName: 'clueArea', }),
    loadUserWorkspaceData({ ...data, dataType: 3, dataName: 'notam', }),
    loadUserWorkspaceData({ ...data, dataType: 4, dataName: 'ntm', }),
    loadUserWorkspaceData({ ...data, dataType: 5, dataName: 'tfr', }),
  ]).then((values)=>{
    workDataLoadChange(false);
    dataInit();
  }).catch(err=>{
    workDataLoadChange(false);
    console.log(err);
  });
}

const controlList = computed(()=> [
  { icon: 'back', title: '返回', fun: close, },
  { icon: 'plus-border', title: '新增数据', fun: addWorkSpaceDataFn, },
  { icon: workDataLoad.value?'loading':'data-plus', title: '数据初始化', fun: workDataInit, },
])

let drawControl,
    drawControlClose = ()=>{
      if(drawControl){
        map.removeControl(drawControl);
      }
      map.off(L.Draw.Event.DRAWSTOP);
    }

const controlInit = ()=>{
  // console.log(map);
  // drawControl = new L.Control.Draw({
  //   position: 'topright',
  //   draw: {
  //     polyline: false,
  //     rectangle: true,
  //     circle: false,
  //     marker: false,
  //     polygon: true,

  //     circlemarker: false
  //   },
  //   edit: {
  //     featureGroup: layerGroup,
  //     remove: false,
  //     edit: false,
  //   }
  // }).addTo(map);
  
  map.on(L.Draw.Event.DRAWSTOP, event=>{
    if(!event.layer)return;
    const layer = event.layer,
          bounds = layer.getBounds && layer.getBounds();
    if(!bounds.isValid()){
      message('无效区域', 2);
      return;
    }
    customLocaleControlInit(layer, {});
    layerGroup.addLayer(layer);
  })
}
const delIdMap = new Map(),
delPolyLayerSucceedFn = (delIds)=>{
  // console.log('delPolyLayerSucceedFn');
  layerGroup.getLayers().forEach(group=>{
    if(!group.getLayers)return;
    delIds.reduceRight((acc, id, index, array)=>{
      const leaflet_id = delIdMap.get(id);
      if(!leaflet_id)return;
      if(group.hasLayer(leaflet_id)){
        group.removeLayer(leaflet_id);
        delIds.splice(index, 1);
      }
      return delIds;
    }, delIds)
  })
}

const customLocaleControlInit = (layer, target)=>{
  // console.log(layer);
  const bounds = layer.getBounds();
  const layerClick = (event)=>{
    const icon = controlMarker && controlMarker._icon;
    if(!icon)return;
    const display = icon.style.display;
    if(display == 'none'){
      icon.style.display = 'unset';
    }else{
      icon.style.display = 'none';
    }
  }
  const app = vueCreateAppInit(CustomLocaleControl, {
    target,
    layer,
    onLayerDelete: ()=>{
      layerGroup.removeLayer(layer);
    },
    layerGroup: layerGroup,
    workSpace: props.workSpace,
    workSpaceDataList: dataList.value,
    onDelPolyLayerSucceedFn: delPolyLayerSucceedFn,
    layerClick,
  });

  const controlMarker = L.marker(bounds.getNorthEast(),{
    icon: L.divIcon({
      iconAnchor: [-5, 0],
    }),
    // interactive: false,
  }).on({
    remove: event=>{
      app.unmount();
    }
  }).addTo(layerGroup);
  nextTick(()=>{
    const icon = controlMarker._icon;
    if(icon){
      icon.style.display = 'none';
      app.mount(icon);
    }
  })
  layer.on({
    remove: event=>{
      layerGroup.removeLayer(controlMarker);
    }
  })

}
const preAnnotationInit = (list)=>{
  list.forEach(item => {
    if(!item['geom'])return;
    const geom = JSON.parse(item['geom']);
    let layer;
    const geojson = L.geoJSON(geom, {
      onEachFeature: (feature, e)=>{
        layer = e;
      }
    })
    layer.addTo(layerGroup);

    customLocaleControlInit(layer, item);
  });
}

const preAnnotationRequest = ()=>{
  queryAnnotation(`3/${ props.workSpace['id'] }`).then(res=>{
    if(res.data.code == 1004){
      preAnnotationInit(res.data.dataList || []);
    }
  }).catch(err=>{
    console.log(err);
  });
}

const dataList = ref([]), dataInit = ()=>{
  layerGroupClear();
  queryUserWorkspaceDataList(props.workSpace['id']).then(res=>{
    if(res.data.code == 1004){
      dataList.value = res.data.dataList;
    }
  }).catch(err=>{
    console.log(err);
  });
  queryRegionAnalysisResultFn();
}
const EditDrawRef = ref();
const layerDataInit = (data)=>{
  const dataChangePolygon = EditDrawRef.value && EditDrawRef.value['dataChangePolygon'];
  dataChangePolygon(data, {});
}

const layerInit = ()=>{
  queryFavoriteDetail({
    bizType: 3,
    favoriteId: props.workSpace['id'],
  }).then(res=>{
    if(res.data.code == 1004){
      layerDataInit(res.data.dataList);
    }
  }).catch(err=>{
    console.log(err);
  });
}

const analysisResultInit = (data)=>{
  data.forEach(target => {
    if(!target['startPoint'])return;
    const latlng = L.latLng(target['startPoint'].split(','));
    const { app, zoomCloseFn, group } = aiComponentCreate(
      latlng,
      { ...target, workSpaceId: props.workSpace['id'], },
      { layerGroup, map }
    );
    layerGroup.addLayer(group);

    group.once({
      remove: event=>{
        zoomCloseFn();
        app?.unmount();
      }
    })
  });
}

const queryRegionAnalysisResultFn = ()=>{
  queryRegionAnalysisResult(props.workSpace['id']).then(res=>{
    if(res.data.code == 1004){
      analysisResultInit(res.data.dataList);
    }
  }).catch(err=>{
    console.log(err);
  });
}

// 飞机舰船类型
const AirAndWarshipList = ref([]),
      getAllAirAndWarshipTypeInit = ()=>{
        getAllAirAndWarshipType({}).then(res=>{
          if(res.data.code == 1004){
            AirAndWarshipList.value = res.data.dataList;
          }
        }).catch(err=>{
          console.log(err);
        });
      }

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  controlInit();
  dataInit();
  preAnnotationRequest();
  getAllAirAndWarshipTypeInit();
  store.commit('polySubmitPortChange', saveAnnotation);
  store.commit('isCustomLayerChange', true);
  // layerInit();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  drawControlClose();
  layerGroupClose();
  store.commit('isCustomLayerChange', false);
  store.commit('polySubmitPortChange', undefined);
});

</script>

<style lang='less'>
.work-space-popup{
  .leaflet-popup-content{
    max-width: 420px;
    max-height: 360px;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar{
      display: none;
    }
  }
}
</style>

<style lang='less' scoped>
.work-space-data-container{
  height: 100%;
  display: flex;
  flex-direction: column;
  .work-space-data-control{
    height: max-content;
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
    .svg-icon{
      cursor: pointer;
      &:hover{
        fill: var(--iconColor_5);
        color: var(--iconColor_5);
      }
    }
  }
  .work-space-data-scrollbar{
    flex: 1;
    :deep(.el-scrollbar__view){
      display: flex;
      flex-direction: column;
      gap: var(--padDefaultSize);
    }
    .work-space-data-item{
      // border: 2px solid var(--borderColor_10);
      border-radius: var(--borderRadiusSize);
      padding: var(--padDefaultSize);
      // background-color: var(--backgroundColor_21);
      backdrop-filter: blur(5px);
      cursor: pointer;
      &:hover{
        // border-color: var(--borderColor_6);
        background-color: var(--backgroundColor_21);
      }
      .item-title{
        line-height: 24px;
        font-size: 16px;
        color: var(--fontColor_24);
      }
      .item-control{
        text-align: right;
        span+span{
          margin-left: 5px;
        }
        .svg-icon{
          cursor: pointer;
          &:hover{
            fill: var(--iconColor_5);
            color: var(--iconColor_5);
          }
        }
      }
    }
    .isHovered{
      background-color: var(--backgroundColor_21);
    }
  }
}
</style>